import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
import { SocialProofPopup } from './components/SocialProofPopup';
const MetaPixel = () => {
  useEffect(() => {
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      w.fbq('init', '2043786956475160');
      w.fbq('track', 'PageView');
    } catch (e) {
      // Pixel failed to load silently
    }
  }, []);
  return <noscript data-id="element-0">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2043786956475160&ev=PageView&noscript=1" alt="" data-id="element-1" />
    </noscript>;
};
export function App() {
  return <>
      <MetaPixel data-id="element-2" />
      <SalesPage data-id="element-3" />
      <SocialProofPopup data-id="element-4" />
    </>;
}